import React from 'react';

// import CalendarIcon from '@material-ui/icons/CalendarToday'

import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

import { INFORM_GENERATOR } from './../../constants/strings/StringsDashboard'


function GenerateInformComponent(props) {
  return (
    <React.Fragment>
      <div className="container-general-inform">
        <div></div>
        <div className="container-book-inform">
          <div className="div-titulo-informes">
            <p className="estilo-titulo-informe" >{INFORM_GENERATOR.GENERATE_INFORM}</p>
          </div>
          {/* <img className="pull-right set-logo-image" height="150px" src={logo} /> */}
          <div id="girar" className='girar'>
            <div className="container-content">
              <div className="content-line">
                <div className="line line-50">
                  <p><span className="error-msg">*</span> {INFORM_GENERATOR.SELECT_TIME_INFORM}</p>
                  <FormControl variant="outlined" className="selcet-container input-select">
                    <InputLabel
                      htmlFor="outlined-age-simple"
                    >

                    </InputLabel>
                    <Select
                      value={props.state.time}
                      onChange={props.onSelectTime}
                      input={
                        <OutlinedInput
                          name="time"
                          id="outlined-age-simple"
                          labelWidth={2}
                        />
                      }
                    >
                      <MenuItem value="">
                        <em>{INFORM_GENERATOR.INFORM_TIME}</em>
                      </MenuItem>
                      {
                        INFORM_GENERATOR.INFORM_TIME_OPS.map((op, i) => {
                          return <MenuItem value={op.value} key={'select-week-inform-' + i}>{op.text}</MenuItem>

                        })
                      }
                    </Select>
                  </FormControl>
                </div>
                {
                  props.showRange &&
                  <div className="content-line" >
                    <div className="line line-50 client-label">
                      <p><span className="error-msg">*</span> {INFORM_GENERATOR.INIT_DATE}</p>
                      <div>
                        <input type={'date'} id="dateRange0" className={"date client-date-picker"} onChange={props.onChangeDate}></input>
                      </div>
                    </div>
                    <div className="line line-50 client-label">
                      <p><span className="error-msg">*</span> {INFORM_GENERATOR.END_DATE}</p>
                      <div>
                        <input type={'date'} id="dateRange1" className={"date client-date-picker"} onChange={props.onChangeDate}></input>
                      </div>
                    </div>
                  </div>
                }
                <div className="line line-100">
                  <p className="error-msg">{props.state.error}</p>
                </div>
                <div className="content-line">
                  <div className="line line-100">
                    <button className="ButtonReset width-300" onClick={props.onGenerate}>{'Generar'}</button>
                  </div>
                </div>
              </div>
            </div> 
          </div>
          <div className="footer-book-infomr">
            <div className="div-titulo-informes alto-footer-book-informe"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GenerateInformComponent;